import { render, staticRenderFns } from "./Kaali.vue?vue&type=template&id=99268698&scoped=true"
import script from "./Kaali.vue?vue&type=script&lang=js"
export * from "./Kaali.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99268698",
  null
  
)

export default component.exports